export interface LanguageOption {
  label: string;
  value: string;
  flag: string;
}
